/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */

import axios from 'axios';
import { debounce } from '../../../common/jQuery';
import auth from '../../../common/auth';

export default {
  // search users by username term, using debounce technique
  searchUsers: debounce(({ commit }, { username }) =>
    axios({
      url: `api/searchUsers?username=${username}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      const users = response.data.data;
      commit('setSearchedUsers', users);
      commit('setHasErrorResult', !users.length);
    }).catch((error) => {
      console.log(`Something went wrong while searching users by username: ${error}`);
      commit('setHasErrorResult', true);
    }), 300),
  // search specific user by whole username
  searchSpecificUser({ commit }, { username }) {
    return axios({
      url: `api/searchUsers?username=${username}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      const user = response.data.data[0];
      if (user) commit('addToExtraUsers', user);
    }).catch((error) => {
      console.log(`Something went wrong while searching specific user: ${error}`);
    });
  },
  fetchFavoriteUsers({ commit }) {
    return axios({
      url: 'api/getFavoriteUsers',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      commit('setFavoriteUsers', response.data.data);
    }).catch((error) => {
      console.log(`Something went wrong while fetching favorite users: ${error}`);
    });
  },
  markFavoriteUser({ commit }, username) {
    commit('toggleFavoriteUser', username);
    return axios({
      url: `api/markFavorite?username=${username}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      console.log(`Reverting...Something went wrong while marking/un-marking favorite user: ${error}`);
      commit('toggleFavoriteUser', username); // revert on error
    });
  },
  fetchBlockedUsers({ commit }) {
    return axios({
      url: 'api/getBlockedUsers',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      commit('setBlockedUsers', response.data.data);
    }).catch((error) => {
      console.log(`Something went wrong while fetching blocked users: ${error}`);
    });
  },
  markBlockedUser({ commit }, username) {
    commit('toggleBlockedUser', username);
    return axios({
      url: `api/markBlocked?username=${username}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      console.log(`Reverting...Something went wrong while blocking/un-blocking user: ${error}`);
      commit('toggleBlockedUser', username); // revert on error
    });
  },
  fetchUserStats({ commit }, username) {
    return axios({
      url: `api/getUserThemeStats?username=${username}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      const { responseEnum, data } = response.data;
      if (responseEnum === 'OPERATION_SUCCESS') {
        commit('setSelectedUserStats', { themes: data.themeDTOS, userInfo: data.userDTO });
      }
    }).catch((error) => {
      console.log(`Something went wrong while fetching user stats: ${error}`);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js